<template>
  <div>
    <el-alert
      title="¡¡¡Aviso!!!, Características funcionales"
      type="info"
      :description="descriptionArlet"
      show-icon
    >
    </el-alert>
    <br />
    <el-row>
      <el-col>
        <el-card>
          <el-tabs type="border-card">
            <el-tab-pane label="Vacaciones">
              <ModuloVacaciones />
            </el-tab-pane>

            <el-tab-pane label="Permisos">
              <ModuloPermisos />
            </el-tab-pane>
            <el-tab-pane label="Amonestacion">
              <ModuloAmonestacion></ModuloAmonestacion>
            </el-tab-pane>
            <el-tab-pane label="Info">
              <InfotVacation />
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import ModuloVacaciones from "@/views/apps/employees/RRHH/Modules/Vacation/Vacaciones.vue";
import ModuloPermisos from "@/views/apps/employees/RRHH/Modules/Permission/Permisos.vue";
import InfotVacation from "@/views/apps/employees/RRHH/Modules/Vacation/InfotVacation.vue";
import ModuloAmonestacion from "@/views/apps/employees/RRHH/Modules/Amonestacion/Amonestacion.vue";

export default {
  name: "Modules",
  components: {
    ModuloVacaciones,
    ModuloPermisos,
    InfotVacation,
    ModuloAmonestacion
  },
  data() {
    return {
      descriptionArlet:
        "• Registrar Solicitudes." +
        "•	Filtro de usuarios por gerencia." +
        "•	Filtro de usuarios por año." +
        "•	Solicitudes por Usuario." +
        "•	Detalles de una solicitud en específico." +
        "•	Opcion para aprobar por parte del supervisor." +
        "•	Opcion para por parte de RRHH." +
        "•	Opcion para rechazar por parte del supervisor." +
        "•	Opcion para rechazar por parte de RRHH." +
        "•	Estados de aprobacion: Pendiente, Rechazada o Aprobada."
    };
  }
};
</script>
